var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "brightnessIconTitle"
  }, "Brightness control") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "brightnessIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6L12 3L9.00001 6H6.00001V9L3 12L6.00001 15V18H8.99999L12 21L15 18H18V15L21 12L18 9V6H15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 9.79086 14.2091 8 12 8V16C14.2091 16 16 14.2091 16 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.5ee8f44e3280c8d130f7d0ee13ac4116.svg";
export { ForwardRef as ReactComponent };